import { Resume } from '@sr/types';
import React from 'react';
import { Box, Checkbox } from '../../ui';
import API from '../../utils/api';

const HidePhoneAndEmail = ({ resume }: { resume: Resume }) => {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { checked } = e.currentTarget;
    API.resume.setProperty({
      path: `${resume.id}/hidePhoneAndEmail`,
      value: checked,
    });
    API.events.logEvent({
      userId: resume.owner,
      eventName: 'Resume Contact Info Hidden',
    });
  }

  return (
    <Box
      as="label"
      sx={{ display: 'flex', alignItems: 'center', py: 2, cursor: 'pointer' }}
    >
      <Box mr={2}>
        <Checkbox
          checked={resume.hidePhoneAndEmail}
          onChange={handleChange}
          data-testid="hide-phone-email"
        />
      </Box>
      Hide phone & email
    </Box>
  );
};

export default HidePhoneAndEmail;
